// Utility helpers to safely read values from unknown JSON payloads
export const asString = (v: unknown, fallback = ''): string => (typeof v === 'string' ? v : fallback);
export const asNumber = (v: unknown, fallback = 0): number => {
    if (typeof v === 'number') return v;
    if (typeof v === 'string' && v.trim() !== '') {
        const n = Number(v);
        return Number.isFinite(n) ? n : fallback;
    }
    return fallback;
};
export const asNullableNumber = (v: unknown): number | null => {
    if (typeof v === 'number') return v;
    if (typeof v === 'string' && v.trim() !== '') {
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    }
    return null;
};
export const asBoolean = (v: unknown, fallback = false): boolean => (typeof v === 'boolean' ? v : fallback);
export const asRecord = (v: unknown): Record<string, unknown> =>
    typeof v === 'object' && v !== null ? (v as Record<string, unknown>) : {};
export const asArray = <T>(v: unknown, mapper: (item: unknown) => T, fallback: T[] = []): T[] =>
    Array.isArray(v) ? v.map(mapper) : fallback;
